import React, { useContext } from "react";
import { ThemeProvider } from "styled-components";
import { AssetContext } from "./asset";
import {defaultTheme, gemeinschaftTheme, swissTheme} from "../theme";

const DynamicThemeProvider = ({ children }) => {
  // Choose theme based on asset context.
  const { isSwissPost, isGemeinschafts3 } = useContext(AssetContext);
  const selectedTheme = isGemeinschafts3? gemeinschaftTheme : isSwissPost ? swissTheme : defaultTheme;

  return <ThemeProvider theme={selectedTheme}>{children}</ThemeProvider>;
};

export default DynamicThemeProvider;
